import type { InventoryPushChannel } from "@redotech/admin-sdk/rpc/schema/ims/get-inventory-push-settings";
import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { Flex } from "@redotech/redo-web/flex";
import { groupInput, input, InputSchema } from "@redotech/ui/form";
import { memo } from "react";

export const inventoryPushForm = groupInput({ shopify: input<boolean>() });

export type InventoryPushForm = InputSchema.Input<typeof inventoryPushForm>;

export type InventoryPushValue = InputSchema.Value<typeof inventoryPushForm>;

export const inventoryPushDefault: InventoryPushValue = { shopify: false };

const CHANNEL_LABELS: Record<InventoryPushChannel, string> = {
  shopify: "Shopify",
};

export const inventoryPushChannels: InventoryPushChannel[] = ["shopify"];

/** One inventory push toggle per sales channel. */
export const InventoryPushToggles = memo(function InventoryPushToggles({
  input,
  connected,
}: {
  input: InventoryPushForm;
  /** Channels the team has an enabled integration for. */
  connected: Record<InventoryPushChannel, boolean>;
}) {
  return (
    <Flex dir="column" gap="md">
      {inventoryPushChannels.map((channel) => (
        <RedoToggle
          description={
            connected[channel]
              ? `Push Redo inventory levels to ${CHANNEL_LABELS[channel]}`
              : `No enabled ${CHANNEL_LABELS[channel]} integration`
          }
          disabled={!connected[channel]}
          key={channel}
          label={`${CHANNEL_LABELS[channel]} Inventory Push`}
          setValue={(value) => input.inputs[channel].setValue(value)}
          size="sm"
          value={input.inputs[channel].value ?? false}
        />
      ))}
    </Flex>
  );
});
